<div class="inline-editor p-1">
    <ng-container *ngIf="col">
        <ng-container  *ngTemplateOutlet="inputTypeSelector(col);"
        ></ng-container>
    </ng-container>
  
    <span class="editor-actions mt-1 ml-auto">
      <button type="button" class="btn btn-sm text-primary" [disabled]="form.controls['Value'].errors" matTooltip="Save"
        (click)="form.controls['Value'].errors?'':onActionSubmit()"><i class="icon-check"></i></button>
      <button type="button" class="btn btn-sm text-danger" matTooltip="Cancel"
        (click)="cancel()"><i class="icon-close"></i></button>
    </span>
  </div>

<ng-template #input>
    <app-input
        [form]="form"
        controlName="Value"
        class="w-100"
        [placeholder]="inputFieldPlaceholder(col)"
        [mask]="inputFieldMask(col)"
        [piiData]="getPIIField(col)"
        [type]="inputFieldType(col)"
        [PIIDecrypted]="piiValue()"
    ></app-input>
</ng-template>
<ng-template #select>
    <app-select
        [form]="form"
        controlName="Value"
        class="w-100"
        [options]="col.dropdownValues?.slice(1)"
    ></app-select>
</ng-template>
<ng-template #select2>
    <app-select
        [form]="form"
        controlName="Value"
        [multiple]="true"
        [value]="form.value.Value"
        class="w-100"
        [options]="col.dropdownValues"
    ></app-select>
</ng-template>
<ng-template #selectSearchScroll>
    <app-select-search-scroll
        [form]="form"
        controlName="Value"
        [options]="[]"
        [relatedFieldKey]="col.fieldKey || ''"
        [minSearchLength]="3"
        [searchable]="true"
        [scrollable]="true"
        class="w-100"
        [selectedValue]="form.value.Value"
        [isConditionComponent]="!col.isRelation"
        [isRelatedDataComponent]="col.isRelation ? true:false"
        [fetchFromServer]="col.isRelation ? true:false"
        [passedTableKey]="tableId"
        [isSelectDisabled]="true"
        [dropdownFieldKey]="col.isRelation ? (col.proxyFieldKey || '') : ''"
        [dropdownType]="col.proxyFieldType"
        [closeOnSelect]="false"
    ></app-select-search-scroll>
</ng-template>
<ng-template #checkbox>
    <app-checkbox
        [form]="form"
        class="w-100"
        controlName="Value"
    ></app-checkbox>
</ng-template>
<ng-template #textarea>
    <app-textarea
        [form]="form"
        class="w-100"
        controlName="Value"
    ></app-textarea>
</ng-template>